
import { createAsyncThunk } from "@reduxjs/toolkit";
import { message } from "antd";
import { Get, Post, Put } from "../../utils/apiUtils";

const msgKey = "user";

function getUserReducer(builder: any) {
    builder
    .addCase(getUser.pending, (state: any) => {
        state.loadStatus = 'loading';
    })
    .addCase(getUser.fulfilled, (state: any, action: any) => {
        state.loadStatus = 'success';
        state.dataSource = action.payload.data;
        state.columns = action.payload.listMeta;
        state.total = action.payload.total;
    })
    .addCase(getUser.rejected, (state: any) => {
        state.loadStatus = 'failed';
    })
}

function submitReducer(builder:any, thunk:any) {
    builder
    .addCase(thunk.pending, (state:any) => {
        state.submitStatus = 'submitting';
        message.open({
            key: msgKey,
            type: 'loading',
            content: 'Saving Data...',
        })
    })
    .addCase(thunk.fulfilled, (state:any, action: any) => {
        state.submitStatus = 'success';
        message.open({
            key: msgKey,
            type: 'success',
            content: 'Data Saved',
        })
    })
    .addCase(thunk.rejected, (state:any) => {
        state.submitStatus = 'failed';
    })
}



export const UserExtraReducer = (builder:any) => {
    getUserReducer(builder);
    submitReducer(builder, addUser);
    submitReducer(builder, updateUserById);
    submitReducer(builder, updateUserConfig);
}

export const getUser = createAsyncThunk(
    'user/getList',
    async (action:any) => {
        return await Get(`/user?${action.query.toString()}`, {msgKey});
    }
);

export const updateUserById = createAsyncThunk(
    'user/updateById',
    async (action:any) => {
        return await Put(`/user/${action.id}`, action.body, {msgKey});
    }
);

export const updateUserConfig = createAsyncThunk(
    'user/updateConfigById',
    async (action:any) => {
        return await Put(`/user/${action.id}/config/${action.configKey}`, action.body, {msgKey});
    }
);


export const addUser = createAsyncThunk(
    'user/add',
    async (data: any) => {
        return await Post(`/user`, data, {msgKey});
    }
);
